import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs";
import { mergeMap, map, catchError } from "rxjs/operators";
import { EmbedParams } from "../../_objects/embedded-report";
import { CustomEncoder } from "../../_shared/custom-encoder";
import { HttpService } from "../http.service";
import { EmbeddedReportContractService } from "../interfaces/embedded-report-contract.service";

@Injectable({
  providedIn: "root"
})
export class EmbeddedReportOnlineService extends HttpService implements EmbeddedReportContractService {
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router
  ) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  // ER01 GET /api/powerbi/report
  getEmbeddedReport(): Observable<EmbedParams> {
    const endpoint = super.getEndpoint("powerbi/report");

    const httpParams = new HttpParams({ encoder: new CustomEncoder() });

    return this.http
      .get<EmbedParams>(endpoint, { withCredentials: super.getWithCredentialsOption(), params: httpParams })
      .pipe(map((response) => response as EmbedParams));
  }
}
